<template>
    <div>
        <!-- 点击 Report information errors 后弹出 -->
        <div class="deep">
            <el-dialog :visible.sync="newDialog" center :close-on-click-modal="true" @close="closeDialog"
                custom-class="dialog_normalsuo" :append-to-body="true">
                <div class="detail_cont">
                    <h3>{{ $t("DataManagement.Identifyacompanymanually") }}</h3> 
                    <h4 class="Identify_title  font1A2332 margin-top20">
                        {{ $t("DataManagement.Pleaseprovideanyrelevantinformation") }}
                    </h4>
                    <div class="rep_list">
                        <el-form ref="Deepform" :model="Deepform" class="report_form" :rules="rules">
                            <div class="report_item">
                                <div class="report_form_box">
                                    <div class="form_box report_form"   >
                                        <div class="fin_cont_box flex_center_between_box">
                                            <div class="fin_modu_box">
                                                <div class="fin_modu">
                                                    <div class="fin_modu_1">
                                                           <el-form-item :label="$t('DataManagement.CompanyName')+':'" prop="CompanyName">
                                                        <el-input :placeholder="$t('DataManagement.Entercompanyname')"
                                                            v-model="Deepform.CompanyName"></el-input>
                                                    </el-form-item>
                                                    <el-form-item :label="$t('DataManagement.Country')+':'" prop="Country">
                                                        <el-select filterable v-model="Deepform.Country"
                                                            :placeholder="$t('DataManagement.Selectcountry')">
                                                            <el-option v-for="item in Coutryoptions" :key="item.val"
                                                                :label="item.value" :value="item.val">
                                                            </el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                    </div>
                                                    <div class="fin_modu_1">
                                                <el-form-item :label="$t('DataManagement.RegistrationID')+':'" prop="RegisterID">
                                                        <el-input :placeholder="$t('DataManagement.EnterRegistrationID')"
                                                            v-model="Deepform.RegisterID"></el-input>
                                                    </el-form-item>
                                                    <el-form-item :label="$t('DataManagement.Address')+':'">
                                                        <el-input :placeholder="$t('DataManagement.EnterAddress')"
                                                            v-model="Deepform.Address"></el-input>
                                                    </el-form-item>
                                                     </div>
                                                 
                                                  
                                                    <el-form-item :label="$t('DataManagement.Otherinformation')+':'" style="width: 100%; margin-bottom: 0px;">
                                                        <el-input style="width: 100%;" v-model="Deepform.demand"
                                                            type="textarea" :placeholder="$t('DataManagement.EnterInformation')"
                                                            class="limit_box" maxlength="500"
                                                            @input="inputChange(Deepform.demand)"
                                                            show-word-limit></el-input>
                                                    </el-form-item>
                                                     <!-- <el-form-item>
                                                        <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
                                                        <el-button @click="resetForm('ruleForm')">重置</el-button>
                                                    </el-form-item> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div class="flex_center margin-top20">
                                    <el-button class="btn_cancel" @click="cancelReport('Deepform')">{{ $t("DataManagement.Cancel") }}</el-button>
                                    <el-button class="btn_export" @click="onSubmitReport('Deepform')">{{ $t("DataManagement.Submit") }}</el-button>
                                    <!-- <el-button class="btn_export" :disabled="disabledReport" @click="onSubmitReport()">Submit</el-button> -->
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import { dataFeedback } from '@/api/companyApi.js';
export default {
    props: {
        showReport: {
            type: Boolean,
            default: false,
        },
        powerStatus: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            Coutryoptions: [],
            
            // newDialog: true,
            tabName: 'Reportmycompany',
            finDialog: false,
            reportDialog2: false,

            Deepform: {
                // year: new Date().getFullYear(),
                CompanyName: '',
                Country: '',
                RegisterID: '',
                Address: '',
                demand: '',
                // coreCompetency: [],
                // businessOutlook: '',
                // uploadFiles: [],
            },
            type: '701',
            filesList: [],

            disabledReport1: true,
            disabledReport2: true,
            disabledReport: true,
           
            addReportList: [{ subject: '', demand: '' }],
        };
    },
    computed: {
        rules(){
            return {
                   CompanyName: [
                    {
                        required: true,
                        message: this.$t("DataManagement.Entercompanyname"),
                        trigger: 'blur',
                    },
                ],
                Country: [
                    { required: true, message: this.$t("DataManagement.Selectcountry"), trigger: 'change' }
                ],
                RegisterID: [

                    { required: true, message: this.$t("DataManagement.EnterRegistrationID"), trigger: 'blur' }
                ]
            }
        },

        newDialog: {
            get() {
                return this.showReport;
            },
            set(newValue) { },
        },
    },

    mounted() {
        this.GetCountry();

        this.huixian();
    },
    methods: {
        GetCountry() {
            let Allcountry = JSON.parse(localStorage.getItem("countryList"))[0]
                .countryList;
            Allcountry.forEach((item) => {
                item.value = item.nameEn;
                item.val = item.countryCode;
            });
            this.Coutryoptions = Allcountry;
        },
        huixian() {
            this.Deepform.CompanyName = this.$route.query.searchname;
        },
        //关闭弹窗
        closeDialog() {

            this.Deepform.RegisterID = '',
                this.Deepform.Country = ''
            this.Deepform.demand = ''
            this.Deepform.Address = ''
            this.Deepform.CompanyName=''
            this.$emit('closeReportDialog', false);
        },

        inputChange(val) {
            val.length > 0 ? (this.disabledReport2 = false) : (this.disabledReport2 = true);
            if (this.disabledReport1 == false && this.disabledReport2 == false) {
                this.disabledReport = false;
            } else {
                this.disabledReport = true;
            }
        },
        //提交report
        onSubmitReport(formName) {
                this.$refs[formName].validate((valid) => {
                  
          if (valid) {
            this.hanldSubmitReport()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
            // this.hanldSubmitReport();
        },
        async hanldSubmitReport() {


            let obj = {
                companyId: this.Deepform.RegisterID,
                // companyId: id3a,
                companyName: this.Deepform.CompanyName,
                country: this.Deepform.Country,
                demand: this.Deepform.demand,
                address: this.Deepform.Address,
            };
            let res = await dataFeedback(obj);

            if (res.code == 200) {
                this.$message({
                    message: res.msg,
                    center: true,
                    type: 'success',
                });
                this.closeDialog();

            } else {
                this.$message({
                    message: res.msg,
                    center: true,
                    type: 'error',
                });
            }
        },
        //取消report
        cancelReport() {
            this.closeDialog();

        },
    },
};
</script>
<style scoped>
.form_box /deep/ .el-input__inner {
    width: 162px;
    height: 34px;
    line-height: 34px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #e7eaed;
    font-size: 18px;
}






.form_box /deep/ .el-select .el-icon-arrow-up:before {
    color: #8497ab !important;
}


.fin_modu.last {
    height: 661px;
}

.form_box /deep/ .el-form-item__content {
    line-height: 34px;
    margin-left: 162px;
    font-size: 18px;
}

/deep/ .el-form-item__label {
    color: #1A2332;
    font-size: 18px; 
    margin-bottom: 0px;
}

.form_box /deep/ .el-form-item__label {
    display: flex;
    align-items: center;
    color: #1A2332;
    font-size: 18px;
    height: 50px;
    line-height: 50px;


}

.form_box /deep/ .el-form-item {
    margin-bottom: 12px;
    display: inline-block;
    font-size: 18px;
}


.form_box /deep/ .out_item {
    margin-bottom: 20px;
}

.form_box /deep/ .el-input__icon {
    height: auto;
}



/* .rep_list {
    padding-bottom: 10px;
} */



.report_form_box {
    padding: 20px;
    background: #F5F5F5;
    border-radius: 6px;
    margin-top: 20px;
    margin-bottom: 20px;
}

.report_form /deep/ .el-input__inner {
    width: 270px;
    height: 50px;
    line-height: 50px;
}

.report_form /deep/ .el-form-item {
    margin-bottom: 20px;
}

.limit_box /deep/ .el-textarea__inner {
    min-height: 80px !important;
    height: 120px;
    width: 100%;
 
    padding: 0 23px 0 7px;
}

.detail_cont {}

.Identify_title{
    font-size: 20px;
}

.fin_modu_1{
    display: flex;
    justify-content: space-between;
}
 
.fin_modu_box{
    width: 100%;
}
.el-button{
  height: 60px;
  min-width: 210px; 
  margin-left: 0px;
}
.flex_center{
  justify-content: center  ; 
  gap: 40px;
}

@media screen and (max-width: 1920px) {
  
   ::v-deep .dialog_normalsuo{
    width: 750px !important;
    /* height: 544px !important; */
  }
  .Identify_title{
    font-size: 16px;
    }

    ::v-deep .el-form-item__label { 
        font-size: 14px; 
    }

    .form_box /deep/ .el-form-item__label { 
        font-size: 14px;
        height: 32px;
        line-height: 28px; 
        
    }
    .report_form /deep/ .el-input__inner {
        width: 200px;
        height: 32px;
        line-height: 28px; 
         font-size: 14px;

    }
    
      ::v-deep  .el-form-item__content{
        line-height: 28px; 
        margin-left: 120px !important;
        font-size: 14px !important;
    }
    
    .report_form_box {
        padding: 15px; 
        border-radius: 5px;
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .el-button{
        height: 45px;
        min-width: 158px;
    }
    .flex_center{ 
        gap: 30px;
    }
    .limit_box /deep/ .el-textarea__inner {
    min-height: 60px !important;
    height: 90px;  
    font-size: 14px;
    padding: 0 23px 0 7px;
    }
    .report_form /deep/ .el-form-item {
        margin-bottom: 15px;
    }
}
@media screen and (max-width: 1439px) {
 
   ::v-deep .dialog_normalsuo{
    width: 670px !important;
            /* height: 485px !important;  */
    }
    .Identify_title{
    font-size: 14px;
    }

    ::v-deep .el-form-item__label { 
        font-size: 12px; 
    }

    .form_box /deep/ .el-form-item__label { 
        font-size: 12px;
        height: 36px;
        line-height: 36px; 
    }
      .report_form /deep/ .el-input__inner {
        width: 180px;
        height: 32px;
        line-height: 24px;
        font-size: 12px;

    }
        ::v-deep   .el-form-item__content{   
        line-height: 24px; 
        margin-left: 108px !important;
        font-size: 12px !important;
    }
     .report_form_box {
        padding: 13px;  
        margin-top: 13px;
        margin-bottom: 13px;
    }
    .el-button{
        height: 40px;
        min-width: 140px;
    }
    .flex_center{ 
        gap: 26px;
    }

      .limit_box /deep/ .el-textarea__inner {
    min-height: 54px !important;
    height: 80px;  
        font-size: 12px; 
    padding: 0 20px 0 6px;
}
   .report_form /deep/ .el-form-item {
        margin-bottom: 13px;
    }
}


</style>
